import { HeaderTypeTokens, StepperStateToken, StepperTypeTokens, } from '@voltmoney/schema';
export const args = {
    title: 'Bank Verification',
    leadIcon: 'https://reactnative.dev/img/tiny_logo.png',
    isBackButton: true,
    leftCta: 'Share',
    leftTitle: {
        label: 'share',
    },
    stepperProps: {
        data: [
            {
                id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
                step: '1',
                title: 'KYC',
                subTitle: 'lorme ipsum doler smit en',
                horizontalTitle: 'KYC',
                status: StepperStateToken.COMPLETED,
                message: '',
            },
            {
                id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
                step: '2',
                title: 'bank Verification',
                subTitle: 'lorme ipsum doler smit en',
                horizontalTitle: 'Bank account',
                status: StepperStateToken.IN_PROGRESS,
                message: '',
            },
            {
                id: '58694a0f-3da1-471f-bd96-145571e29d72',
                step: '3',
                title: 'Mandate',
                subTitle: 'lorme ipsum doler smit en',
                horizontalTitle: 'AutoPay',
                status: StepperStateToken.NOT_STARTED,
                statusText: StepperStateToken.NOT_STARTED,
                message: 'Something Went Wrong',
            },
            {
                id: '58694a0f-3da1-471f-bd96-145571e29d74',
                step: '4',
                title: 'Loan Agreement',
                subTitle: 'lorme ipsum doler smit en',
                horizontalTitle: 'Agreement',
                status: StepperStateToken.NOT_STARTED,
                message: '',
            },
        ],
        type: StepperTypeTokens.HORIZONTAL,
    },
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(HeaderTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
